import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Shared shell for all legal / static pages (CGU, Privacy, Legal notice, Contact).
 * Renders a compact page with the MPY brand and a "back home" link.
 */
export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[color:var(--seafoam)]">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-[color:var(--seafoam)]/85 border-b border-slate-200/70">
        <div className="max-w-3xl mx-auto px-5 md:px-8 py-3.5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-back-home">
            <img
              src="/branding/app_icon.png"
              alt="Ma Petite Yole"
              className="w-9 h-9 rounded-xl object-cover shadow-sm"
            />
            <div className="brand-wordmark text-[color:var(--deep)] text-[18px] leading-none">
              Ma Petite Yole
            </div>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-slate-500 hover:text-[color:var(--coral)] transition-colors"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 md:px-8 py-10 md:py-14">
        <div className="text-[10px] font-black uppercase tracking-[0.28em] text-[color:var(--coral)] mb-2">
          Ma Petite Yole
        </div>
        <h1 className="brand-wordmark text-4xl sm:text-5xl text-[color:var(--deep)] leading-tight">
          {title}
        </h1>
        {updated && (
          <p className="text-xs text-slate-500 mt-3 font-mono">
            Dernière mise à jour : {updated}
          </p>
        )}

        <article className="prose prose-slate max-w-none mt-8 text-[15px] leading-relaxed text-slate-700 [&_h2]:brand-wordmark [&_h2]:text-[color:var(--deep)] [&_h2]:text-2xl [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:font-bold [&_h3]:text-[color:var(--deep)] [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-lg [&_a]:text-[color:var(--ocean)] [&_a]:font-bold [&_a:hover]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_li]:my-1 [&_p]:my-3 [&_strong]:text-[color:var(--deep)]">
          {children}
        </article>

        <div className="mt-12 pt-6 border-t border-slate-200 text-center text-xs text-slate-400">
          <div className="brand-signature text-[10px] mb-1">Prono. Vibré. Gagné.</div>
          <div>© {new Date().getFullYear()} Ma Petite Yole · Fabien Deris EI</div>
        </div>
      </main>
    </div>
  );
}
